import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {FlatButton,FontIcon} from 'material-ui';
import {connect} from 'react-redux';

export class HomePage extends React.Component {
  render() {
    const { currentUser } = this.props;

    if (currentUser.name == 'no login') {
      return <p>Please sign in</p>
    }

    const style = {
      height: '46px',
      lineHeight: '46px',
      marginRight: '10px'
    }

    const labelStyle = {
      textTransform: 'none',
      fontSize: '20px'
    }

    return (
      <div className="home-nav">
        <FlatButton
        label="Projects"
        containerElement={<Link to="/projects" />}
        primary={true}
        style={style}
        labelStyle={labelStyle}
        icon={<FontIcon className="material-icons" >assignment</FontIcon>} />
        <FlatButton
        label="Members"
        containerElement={<Link to="/members" />}
        primary={true}
        style={style}
        labelStyle={labelStyle}
        icon={<FontIcon className="material-icons">face</FontIcon>} />
        <FlatButton
        label="New Task"
        containerElement={<Link to="/members/tasks/new" />}
        primary={true}
        style={style}
        labelStyle={labelStyle}
        icon={<FontIcon className="material-icons">edit</FontIcon>} />


      </div>
    );
  }
}

HomePage.propTypes = {
  currentUser: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser
  };
}

export default connect(
  mapStateToProps
)(HomePage);



/** WEBPACK FOOTER **
 ** ./src/components/HomePage.js
 **/